import {
  LOGIN,
  LOGOUT,
  AUTH_ERRORS,
  LOGIN_REQUEST,
  SIGNUP_REQUEST,
  RESET_PASSWORD_REQUEST,
  VALIDATE_TOKEN_COMPLETE,
  SESSION_TIMEOUT,
  DISMISS_SESSION_TIMEOUT,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_ERROR,
  SHOW_NOTICE,
  HIDE_NOTICE,
  SUBMIT_COMPLETED,
  RESET_SUBMIT_SUCCEEDED,
} from './actionTypes';

import { getResData } from './selectors';

const defaultState = {
  tokenValidating: true,
  sessionTimeout: false,
  user: null,
  errors: null,
  submitting: false,
  noticeText: null,
  submitSucceeded: false,
};

export const authReducer = (state = defaultState, action) => {
  const { type, res, noticeText, errors } = action;

  switch (type) {
    case VALIDATE_TOKEN_COMPLETE:
      return { ...state, tokenValidating: false };
    case SESSION_TIMEOUT:
      return { ...state, sessionTimeout: true };
    case DISMISS_SESSION_TIMEOUT:
      return { ...state, sessionTimeout: false, user: null };
    case LOGIN:
      return {
        ...state,
        user: getResData(res),
        errors: null,
        submitting: false,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        errors: null,
        submitting: false,
      };
    case AUTH_ERRORS:
      return {
        ...state,
        user: null,
        errors,
        submitting: false,
      };
    case UPDATE_PASSWORD_ERROR:
      return {
        ...state,
        errors,
        submitting: false,
      };
    case SHOW_NOTICE:
      return {
        ...state,
        noticeText,
        errors: null,
        submitting: false,
      };
    case HIDE_NOTICE:
      return {
        ...state,
        noticeText: null,
      };
    case SIGNUP_REQUEST:
    case LOGIN_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        submitting: true,
      };
    case SUBMIT_COMPLETED:
      return {
        ...state,
        submitting: false,
        submitSucceeded: true,
      };
    case RESET_SUBMIT_SUCCEEDED:
      return {
        ...state,
        submitSucceeded: false,
      };
    default:
      return state;
  }
};
